<template>
  <div class="index-module_articleWrap_2Zphx">
      <div class="zhemo">科普：何为量化选股？</div>
    <p class="index-module_textWrap_3ygOc">
      <strong>量化选股</strong
      >就是利用数量化的方法选择股票组合，期望该股票组合能够获得超越基准收益率的投资行为。量化选股策略总的来说可以分为两类：<strong
        >第一类是基本面选股，第二类是市场行为选股。</strong
      >
    </p>
    <figure>
      
    </figure>
    <p class="index-module_textWrap_3ygOc">
      <strong>基本面选股</strong
      >主要有<em>多因子模型、风格轮动模型和行业轮动模型</em>。<strong>市场行为选股</strong>主要有资金流模型、动量反转模型、一致预期模型、趋势追踪模型和筹码选股模型。
    </p>
    <p class="index-module_textWrap_3ygOc">
      <strong>多因子模型</strong
      >是应用最广泛的一种选股模型，基本原理是采用一系列的因子作为选股标准，满足这些因子的股票则被买入，不满足的则卖出。多因子模型相对来说比较稳定，因为在不同市场条件下，总有一些因子会发挥作用。
    </p>
    <p class="index-module_textWrap_3ygOc">
      <strong>风格轮动模型</strong
      >是利用市场的风格特征进行投资，比如有时候市场偏好小盘股，有时候偏好大盘股，如果是风格转换的初期介入，则可以获得较大的超额收益。
    </p>
    <figure>
     
    </figure>
    <p class="index-module_textWrap_3ygOc">
      <strong>行业轮动</strong
      >与风格轮动类似，由于经济周期的原因，总有一些行业先启动，有的行业跟随。在经济周期过程中，依次对这些轮动的行业进行配置，则比买入持有策略有更好的效果。
    </p>
    <p class="index-module_textWrap_3ygOc">
      <strong>资金流选股</strong
      >的基本思想是利用资金的流向来判断股票的涨跌，如果资金流入，股票应该会上涨，如果资金流出，则股票应该下跌。所以将资金流入流出的情况编成指标，则可以利用该指标来判断在未来一段时间股票的涨跌情况了。
    </p>
    <p class="index-module_textWrap_3ygOc">
      <strong>动量反转模型</strong
      >是指股票的的强弱变化情况，过去一段时间强的股票，在未来一段时间继续保持强势，过去一段时间弱的股票，在未来一段时间继续弱势，这叫做动量效应。过去一段时间强的股票在未来一段时间会走弱，过去一段时间弱势的股票在未来一段时间会走强，这叫做反转效应。如果判定动量效应会持续，则应该买入强势股，如果判断会出现反转效应，则应该买入弱势股。
    </p>
    <p class="index-module_textWrap_3ygOc">
      <strong>一致预期</strong
      >是指市场上的投资者可能会对某些信息产生一致的看法，比如大多数分析师看好某一个股票，可能这个股票在未来一段时间会上涨；如果大多数分析师看空某一个股票，可能这个股票在未来一段时间会下跌。一致预期策略就是利用大多数分析师的看法来进行股票的买入卖出操作。
      <br />
    </p>
    <p class="index-module_textWrap_3ygOc">
      <strong>趋势追踪</strong
      >是属于图形交易的一种，就是当股价出现上涨趋势的时候，则追涨买入；如果出现下跌趋势的时候，则杀跌卖出，本质上是一种追涨杀跌策略。判断趋势的指标有很多种，包括
      MA ， EMA ， MACD 等，其中最简单也是最有效的是均线策略。
    </p>
    <p class="index-module_textWrap_3ygOc">
      <strong>筹码选股</strong
      >是另外一种市场行为策略，基本思想是，如果主力资金要拉升一支股票，会慢慢收集筹码，如果主力资金要卖出一支股票，则会慢慢分派筹码，所以根据筹码的分布和变动情况，就可以预测股票的未来是上涨还是下跌。
    </p>
    <figure>
      
    </figure>
    <br />
    <blockquote>
      <p class="index-module_textWrap_3ygOc">
        <em
          >有关量化选股业绩评价要从两个方面来考虑，一个是收益率，一个是风险指数，只是收益率高的策略并不能成为最好的策略，应该综合考虑收益率和风险情况才能判断一个选股的策略的好坏。量化选股需要考虑的是在承担多大的风险情况下的收益率情况。</em
        >
      </p>
    </blockquote>
    <p class="free">（来源：量化投资布道者）</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
strong{
    font-weight: bold;
}
</style>